import React from "react";
import { G, Path, Polygon } from "react-native-svg";

export const svgs: any = {
  EditUser: {
    svg: (
      <Path
        {...{ tabIndex: -1 }}
        fill="currentColor"
        d="M402.6 83.2l90.2 90.2c3.8 3.8 3.8 10 0 13.8L274.4 405.6l-92.8 10.3c-12.4 1.4-22.9-9.1-21.5-21.5l10.3-92.8L388.8 83.2c3.8-3.8 10-3.8 13.8 0zm162-22.9l-48.8-48.8c-15.2-15.2-39.9-15.2-55.2 0l-35.4 35.4c-3.8 3.8-3.8 10 0 13.8l90.2 90.2c3.8 3.8 10 3.8 13.8 0l35.4-35.4c15.2-15.3 15.2-40 0-55.2zM384 346.2V448H64V128h229.8c3.2 0 6.2-1.3 8.5-3.5l40-40c7.6-7.6 2.2-20.5-8.5-20.5H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V306.2c0-10.7-12.9-16-20.5-8.5l-40 40c-2.2 2.3-3.5 5.3-3.5 8.5z"
      ></Path>
    ),
    viewBox: "0 0 576 512",
  },
  UserGroup: {
    svg: (
      <Path
        {...{ tabIndex: -1 }}
        fill="currentColor"
        d="M192 256c61.9 0 112-50.1 112-112S253.9 32 192 32 80 82.1 80 144s50.1 112 112 112zm76.8 32h-8.3c-20.8 10-43.9 16-68.5 16s-47.6-6-68.5-16h-8.3C51.6 288 0 339.6 0 403.2V432c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48v-28.8c0-63.6-51.6-115.2-115.2-115.2zM480 256c53 0 96-43 96-96s-43-96-96-96-96 43-96 96 43 96 96 96zm48 32h-3.8c-13.9 4.8-28.6 8-44.2 8s-30.3-3.2-44.2-8H432c-20.4 0-39.2 5.9-55.7 15.4 24.4 26.3 39.7 61.2 39.7 99.8v38.4c0 2.2-.5 4.3-.6 6.4H592c26.5 0 48-21.5 48-48 0-61.9-50.1-112-112-112z"
      ></Path>
    ),
    viewBox: "0 0 600 590",
  },
  TimesCircle: {
    svg: (
      <Path
        {...{ tabIndex: -1 }}
        fill="currentColor"
        d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm121.6 313.1c4.7 4.7 4.7 12.3 0 17L338 377.6c-4.7 4.7-12.3 4.7-17 0L256 312l-65.1 65.6c-4.7 4.7-12.3 4.7-17 0L134.4 338c-4.7-4.7-4.7-12.3 0-17l65.6-65-65.6-65.1c-4.7-4.7-4.7-12.3 0-17l39.6-39.6c4.7-4.7 12.3-4.7 17 0l65 65.7 65.1-65.6c4.7-4.7 12.3-4.7 17 0l39.6 39.6c4.7 4.7 4.7 12.3 0 17L312 256l65.6 65.1z"
      ></Path>
    ),
    viewBox: "0 0 512 512",
  },
  CheckCircle: {
    svg: (
      <Path
        {...{ tabIndex: -1 }}
        fill="currentColor"
        d="M504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zM227.314 387.314l184-184c6.248-6.248 6.248-16.379 0-22.627l-22.627-22.627c-6.248-6.249-16.379-6.249-22.628 0L216 308.118l-70.059-70.059c-6.248-6.248-16.379-6.248-22.628 0l-22.627 22.627c-6.248 6.248-6.248 16.379 0 22.627l104 104c6.249 6.249 16.379 6.249 22.628.001z"
      ></Path>
    ),
    viewBox: "0 0 512 512",
  },
  Unlock: {
    svg: (
      <Path
        {...{ tabIndex: -1 }}
        fill="currentColor"
        d="M400 256H152V152.9c0-39.6 31.7-72.5 71.3-72.9 40-.4 72.7 32.1 72.7 72v16c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24v-16C376 68 307.5-.3 223.5 0 139.5.3 72 69.5 72 153.5V256H48c-26.5 0-48 21.5-48 48v160c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V304c0-26.5-21.5-48-48-48zM264 408c0 22.1-17.9 40-40 40s-40-17.9-40-40v-48c0-22.1 17.9-40 40-40s40 17.9 40 40v48z"
      ></Path>
    ),
    viewBox: "0 0 448 512",
  },
  Pencil: {
    svg: (
      <G>
        <Polygon points="0,303.947 0,383.947 80,383.947 316.053,147.893 236.053,67.893" />
        <Path d="M377.707,56.053L327.893,6.24c-8.32-8.32-21.867-8.32-30.187,0l-39.04,39.04l80,80l39.04-39.04C386.027,77.92,386.027,64.373,377.707,56.053z" />
      </G>
    ),
    viewBox: "0 0 383.947 383.947",
  },
  Trash: {
    svg: (
      <Path
        {...{ tabIndex: -1 }}
        fill="currentColor"
        d="M432 32H312l-9.4-18.7A24 24 0 0 0 281.1 0H166.8a23.72 23.72 0 0 0-21.4 13.3L136 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zM53.2 467a48 48 0 0 0 47.9 45h245.8a48 48 0 0 0 47.9-45L416 128H32z"
      ></Path>
    ),
    viewBox: "0 0 448 512",
  },
  Gear: {
    svg: (
      <Path
        fill="currentColor"
        d="M487.4 315.7l-42.6-24.6c4.3-23.2 4.3-47 0-70.2l42.6-24.6c4.9-2.8 7.1-8.6 5.5-14-11.1-35.6-30-67.8-54.7-94.6-3.8-4.1-10-5.1-14.8-2.3L380.8 110c-17.9-15.4-38.5-27.3-60.8-35.1V25.8c0-5.6-3.9-10.5-9.4-11.7-36.7-8.2-74.3-7.8-109.2 0-5.5 1.2-9.4 6.1-9.4 11.7V75c-22.2 7.9-42.8 19.8-60.8 35.1L88.7 85.5c-4.9-2.8-11-1.9-14.8 2.3-24.7 26.7-43.6 58.9-54.7 94.6-1.7 5.4.6 11.2 5.5 14L67.3 221c-4.3 23.2-4.3 47 0 70.2l-42.6 24.6c-4.9 2.8-7.1 8.6-5.5 14 11.1 35.6 30 67.8 54.7 94.6 3.8 4.1 10 5.1 14.8 2.3l42.6-24.6c17.9 15.4 38.5 27.3 60.8 35.1v49.2c0 5.6 3.9 10.5 9.4 11.7 36.7 8.2 74.3 7.8 109.2 0 5.5-1.2 9.4-6.1 9.4-11.7v-49.2c22.2-7.9 42.8-19.8 60.8-35.1l42.6 24.6c4.9 2.8 11 1.9 14.8-2.3 24.7-26.7 43.6-58.9 54.7-94.6 1.5-5.5-.7-11.3-5.6-14.1zM256 336c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80z"
      />
    ),
    viewBox: "0 0 512 512",
  },
  CaretRightArrow: {
    svg: (
      <Path
        {...{ tabIndex: -1 }}
        d="M0 384.662V127.338c0-17.818 21.543-26.741 34.142-14.142l128.662 128.662c7.81 7.81 7.81 20.474 0 28.284L34.142 398.804C21.543 411.404 0 402.48 0 384.662z"
      ></Path>
    ),
    viewBox: "0 0 192 512",
  },
  Info: {
    svg: (
      <Path
        fill="currentColor"
        d="M256 8C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm0 110c23.196 0 42 18.804 42 42s-18.804 42-42 42-42-18.804-42-42 18.804-42 42-42zm56 254c0 6.627-5.373 12-12 12h-88c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h12v-64h-12c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h64c6.627 0 12 5.373 12 12v100h12c6.627 0 12 5.373 12 12v24z"
      />
    ),
    viewBox: "0 0 512 512",
  },
  ChevronRight: {
    svg: (
      <Path
        fill="currentColor"
        d="M285.476 272.971L91.132 467.314c-9.373 9.373-24.569 9.373-33.941 0l-22.667-22.667c-9.357-9.357-9.375-24.522-.04-33.901L188.505 256 34.484 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L285.475 239.03c9.373 9.372 9.373 24.568.001 33.941z"
      />
    ),
    viewBox: "0 0 320 512",
  },
  UploadFile: {
    svg: (
      <Path
        {...{ tabIndex: -1 }}
        id="ic_file_upload_24px"
        d="M8.265,13.613h4.9v-4.9h3.265L12.446,4.732,10.714,3,8.364,5.351,7.283,6.432,5,8.715H8.265ZM5,15.245H16.429v1.633H5Z"
        transform="translate(-5 -3)"
        fill="#fff"
      />
    ),
    viewBox: "0 0 11.429 13.878",
  },
  AlertError: {
    svg: (
      <React.Fragment>
        <G
          id="Design---MVP"
          stroke="none"
          strokeWidth="1"
          fill="none"
          fillRule="evenodd"
        >
          <G
            id="6.1-Can't-login---Blocked"
            transform="translate(-179.000000, -180.000000)"
          >
            <G
              id="Illustration/Software/Error"
              transform="translate(179.000000, 180.000000)"
            >
              <G id="Software-Error">
                <G>
                  <G id="Layer_2">
                    <G id="Software">
                      <Path
                        d="M48.2516364,41.3178182 L82.0756364,99.904 C83.4566139,102.293822 83.4571984,105.238977 82.0771695,107.629347 C80.6971406,110.019716 78.146317,111.49187 75.3861818,111.490909 L7.73818182,111.490909 C4.97804664,111.49187 2.42722303,110.019716 1.04719412,107.629347 C-0.332834793,105.238977 -0.332250304,102.293822 1.04872727,99.904 L34.8727273,41.3178182 C36.2519729,38.9271515 38.8021808,37.4542514 41.5621818,37.4542514 C44.3221828,37.4542514 46.8723907,38.9271515 48.2516364,41.3178182 Z"
                        id="_Polygon_2"
                        fill="#FFC400"
                        fillRule="nonzero"
                      ></Path>
                      <Path
                        d="M44.4029091,83.8523636 L45.8690909,61.2741818 C45.9535676,59.9844525 45.5001503,58.7173268 44.6166105,57.7739841 C43.7330707,56.8306414 42.4983111,56.295325 41.2058182,56.2952727 L41.2058182,56.2952727 C39.9133252,56.295325 38.6785656,56.8306414 37.7950259,57.7739841 C36.9114861,58.7173268 36.4580688,59.9844525 36.5425455,61.2741818 L38.0087273,83.8523636 C38.118645,85.5377766 39.5168257,86.8491277 41.2058182,86.8509091 L41.2058182,86.8509091 C42.8948107,86.8491277 44.2929914,85.5377766 44.4029091,83.8523636 L44.4029091,83.8523636 Z"
                        id="Shape"
                        fill="#253858"
                        fillRule="nonzero"
                      ></Path>
                      <Path
                        d="M36.3389091,95.8363636 C36.3261188,97.2070911 36.893783,98.5192601 37.9015625,99.4484735 C38.9093421,100.377687 40.2631749,100.837216 41.6283636,100.713455 C44.2541423,100.474074 46.2263106,98.2103014 46.1036175,95.5764899 C45.9809244,92.9426784 43.8068432,90.8720537 41.1701818,90.8778182 C38.4696943,90.9196946 36.3105677,93.1357002 36.3389091,95.8363636 Z"
                        id="Shape"
                        fill="#253858"
                        fillRule="nonzero"
                      ></Path>
                      <Path
                        d="M46.6836364,14.3410909 L42.9112727,0.738181818 C42.8738037,0.597488695 42.7436188,0.501716102 42.5981502,0.50782823 C42.4526815,0.513940357 42.3309894,0.620296019 42.3054545,0.763636364 L39.9330909,13.5418182 L36.9803636,12.992 C36.875312,12.9724817 36.7676038,13.0083406 36.6952158,13.0869332 C36.6228279,13.1655259 36.5959277,13.2758132 36.624,13.3789091 L40.3963636,26.9818182 C40.4283521,27.1233882 40.5541338,27.2239198 40.6992727,27.2239198 C40.8444117,27.2239198 40.9701934,27.1233882 41.0021818,26.9818182 L43.3745455,14.2036364 L46.3272727,14.728 C46.4323244,14.7475183 46.5400326,14.7116594 46.6124205,14.6330668 C46.6848085,14.5544741 46.7117087,14.4441868 46.6836364,14.3410909 Z"
                        id="Shape"
                        fill="#FFC400"
                        fillRule="nonzero"
                      ></Path>
                      <Path
                        d="M33.152,21.7941818 L27.6130909,17.4414545 C27.5627732,17.4018012 27.4917338,17.4021667 27.4418268,17.4423358 C27.3919198,17.4825049 27.3763803,17.5518247 27.4043636,17.6094545 L30.2196364,23.4181818 L28.8654545,24.0850909 C28.8270619,24.1105577 28.8039809,24.1535651 28.8039809,24.1996364 C28.8039809,24.2457076 28.8270619,24.288715 28.8654545,24.3141818 L34.3992727,28.6669091 C34.4495905,28.7065624 34.5206298,28.7061969 34.5705368,28.6660278 C34.6204438,28.6258588 34.6359833,28.5565389 34.608,28.4989091 L31.7723636,22.68 L33.1265455,22.0232727 C33.1681177,22.0023806 33.1962994,21.9618765 33.2014374,21.9156345 C33.2065754,21.8693924 33.1879722,21.8236899 33.152,21.7941818 Z"
                        id="Shape"
                        fill="#FFAB00"
                        fillRule="nonzero"
                      ></Path>
                      <Path
                        d="M58.6218182,19.1418182 C58.0261818,19.9512727 53.0218182,16.2909091 52.4312727,17.1054545 C51.8407273,17.92 56.84,21.5803636 56.2494545,22.3949091 C55.6589091,23.2094545 50.6494545,19.544 50.0538182,20.3585455 C49.4581818,21.1730909 54.4625455,24.8334545 53.8669091,25.648 C53.2712727,26.4625455 48.2669091,22.7970909 47.6712727,23.6116364 C47.0756364,24.4261818 52.08,28.0865455 51.4843636,28.9010909"
                        id="Shape"
                        stroke="#344563"
                        strokeWidth="1.01818182"
                        strokeLinecap="round"
                      ></Path>
                      <Path
                        d="M61.0501818,33.1876364 C60.3069091,33.8647273 57.4610909,30.7541818 56.7178182,31.4363636 C55.9745455,32.1185455 58.8203636,35.2290909 58.0770909,35.9061818 C57.3338182,36.5832727 54.488,33.4727273 53.7447273,34.1549091 C53.3985455,34.4705455 53.8261818,35.3105455 54.3098182,36.1912727"
                        id="Shape"
                        stroke="#5E6C84"
                        strokeWidth="1.01818182"
                        strokeLinecap="round"
                      ></Path>
                      <Path
                        d="M22.8072727,33.0909091 C23.7338182,33.4829091 25.3527273,29.5934545 26.2996364,29.9854545 C27.2465455,30.3774545 25.592,34.2618182 26.5185455,34.6538182 C27.4450909,35.0458182 29.064,31.1563636 30.0109091,31.5483636 C30.4436364,31.7316364 30.3214545,32.6632727 30.1585455,33.6509091"
                        id="Shape"
                        stroke="#5E6C84"
                        strokeWidth="1.01818182"
                        strokeLinecap="round"
                      ></Path>
                    </G>
                  </G>
                </G>
              </G>
            </G>
          </G>
        </G>
      </React.Fragment>
    ),
    viewBox: "0 0 84 112",
  },
  Hammer: {
    svg: (
      <Path
        {...{ tabIndex: -1 }}
        fill="currentColor"
        d="M571.31 193.94l-22.63-22.63c-6.25-6.25-16.38-6.25-22.63 0l-11.31 11.31-28.9-28.9c5.63-21.31.36-44.9-16.35-61.61l-45.25-45.25c-62.48-62.48-163.79-62.48-226.28 0l90.51 45.25v18.75c0 16.97 6.74 33.25 18.75 45.25l49.14 49.14c16.71 16.71 40.3 21.98 61.61 16.35l28.9 28.9-11.31 11.31c-6.25 6.25-6.25 16.38 0 22.63l22.63 22.63c6.25 6.25 16.38 6.25 22.63 0l90.51-90.51c6.23-6.24 6.23-16.37-.02-22.62zm-286.72-15.2c-3.7-3.7-6.84-7.79-9.85-11.95L19.64 404.96c-25.57 23.88-26.26 64.19-1.53 88.93s65.05 24.05 88.93-1.53l238.13-255.07c-3.96-2.91-7.9-5.87-11.44-9.41l-49.14-49.14z"
      />
    ),
    viewBox: "0 0 576 512",
  },
  Random: {
    svg: (
      <Path
        fill="currentColor"
        d="M504.971 359.029c9.373 9.373 9.373 24.569 0 33.941l-80 79.984c-15.01 15.01-40.971 4.49-40.971-16.971V416h-58.785a12.004 12.004 0 0 1-8.773-3.812l-70.556-75.596 53.333-57.143L352 336h32v-39.981c0-21.438 25.943-31.998 40.971-16.971l80 79.981zM12 176h84l52.781 56.551 53.333-57.143-70.556-75.596A11.999 11.999 0 0 0 122.785 96H12c-6.627 0-12 5.373-12 12v56c0 6.627 5.373 12 12 12zm372 0v39.984c0 21.46 25.961 31.98 40.971 16.971l80-79.984c9.373-9.373 9.373-24.569 0-33.941l-80-79.981C409.943 24.021 384 34.582 384 56.019V96h-58.785a12.004 12.004 0 0 0-8.773 3.812L96 336H12c-6.627 0-12 5.373-12 12v56c0 6.627 5.373 12 12 12h110.785c3.326 0 6.503-1.381 8.773-3.812L352 176h32z"
      />
    ),
    viewBox: "0 0 512 512",
  },
  UserCheck: {
    svg: (
      <Path
        fill="currentColor"
        d="M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-74.2-60.2-134.4-134.4-134.4zm323-128.4l-27.8-28.1c-4.6-4.7-12.1-4.7-16.8-.1l-104.8 104-45.5-45.8c-4.6-4.7-12.1-4.7-16.8-.1l-28.1 27.9c-4.7 4.6-4.7 12.1-.1 16.8l81.7 82.3c4.6 4.7 12.1 4.7 16.8.1l141.3-140.2c4.6-4.7 4.7-12.2.1-16.8z"
      />
    ),
    viewBox: "0 0 640 512",
  },
  Barcode: {
    svg: (
      <G {...{ tabIndex: -1 }}>
        <G>
          <Path d="m512.028 142.949h-30v-45.004h-45.033v-30h75.033z" />
        </G>
        <G>
          <Path d="m30 142.949h-30v-75.004h75.034v30h-45.034z" />
        </G>
        <G>
          <Path d="m512.028 444.083h-75.033v-30h45.033v-45.003h30z" />
        </G>
        <G>
          <Path d="m75.034 444.083h-75.034v-75.003h30v45.003h45.034z" />
        </G>
        <G>
          <Path d="m64.264 125.792h30v260.443h-30z" />
        </G>
        <G>
          <Path d="m123.179 125.792h30v200.439h-30z" />
        </G>
        <G>
          <Path d="m182.095 125.792h30v200.439h-30z" />
        </G>
        <G>
          <Path d="m241.01 125.792h30v260.443h-30z" />
        </G>
        <G>
          <Path d="m299.926 125.792h30v260.443h-30z" />
        </G>
        <G>
          <Path d="m417.757 125.792h30v260.443h-30z" />
        </G>
        <G>
          <Path d="m358.841 125.792h30v200.439h-30z" />
        </G>
        <G>
          <Path d="m123.179 356.234h30v30.002h-30z" />
        </G>
        <G>
          <Path d="m182.095 356.234h30v30.002h-30z" />
        </G>
        <G>
          <Path d="m358.841 356.234h30v30.002h-30z" />
        </G>
      </G>
    ),
    viewBox: "0 0 512.028 512.028",
  },
  EquipmentType: {
    svg: (
      <G {...{ tabIndex: -1 }}>
        <G
          {...{ tabIndex: -1 }}
          id="Group_2634"
          data-name="Group 2634"
          transform="translate(0 0)"
        >
          <Path
            {...{ tabIndex: -1 }}
            id="Path_349"
            data-name="Path 349"
            d="M11.571,110.137a2.715,2.715,0,1,1-2.714-2.776,2.747,2.747,0,0,1,2.714,2.776Zm-1.357,0a1.357,1.357,0,1,0-1.357,1.388,1.373,1.373,0,0,0,1.357-1.388Zm-3.7-2.776H.436a.448.448,0,0,0-.436.448v1.354a.448.448,0,0,0,.436.448H5.312a3.685,3.685,0,0,1,1.206-2.241Zm19.254,2.776a2.715,2.715,0,1,1-2.714-2.776,2.747,2.747,0,0,1,2.714,2.776Zm-1.357,0a1.357,1.357,0,1,0-1.357,1.388,1.373,1.373,0,0,0,1.357-1.388Zm6.155-2.33v1.354a.448.448,0,0,1-.436.448H26.6a3.571,3.571,0,0,0-7.091,0H12.4a3.685,3.685,0,0,0-1.207-2.241h6.736V94.6a.883.883,0,0,1,.873-.9h4.118a3.47,3.47,0,0,1,2.893,1.572l2.655,4.021a3.627,3.627,0,0,1,.6,2v6.062H30.13a.448.448,0,0,1,.448.457Zm-4.42-8.4-2.123-3.086a.433.433,0,0,0-.357-.19H20.354a.448.448,0,0,0-.436.448v3.086a.448.448,0,0,0,.436.448h5.435a.448.448,0,0,0,.362-.707Z"
            transform="translate(0 -92.7)"
          />
          <Path
            {...{ tabIndex: -1 }}
            id="Union_17"
            data-name="Union 17"
            d="M.9,13.449a.9.9,0,0,1-.9-.9V.9A.9.9,0,0,1,.9,0H15.541a.9.9,0,0,1,.9.9V12.552a.9.9,0,0,1-.9.9Zm.6-11.058v8.667a.9.9,0,0,0,.279.65l12.956-9.9a.9.9,0,0,0-.683-.317H2.391a.9.9,0,0,0-.9.9Z"
            transform="translate(0 0)"
          />
        </G>
      </G>
    ),
    viewBox: "0 0 30.578 20.092",
  },
  QuoteIcon: {
    svg: (
      <G {...{ tabIndex: -1 }}>
        <G>
          <G>
            <Polygon points="320,0 320,128 448,128" />
          </G>
        </G>
        <G>
          <G>
            <Path
              d="M320,160c-17.632,0-32-14.368-32-32V0H96C78.368,0,64,14.368,64,32v448c0,17.664,14.368,32,32,32h320
			c17.664,0,32-14.336,32-32V160H320z M176,97.984V80c0-8.832,7.168-16,16-16c8.832,0,16,7.168,16,16v18.016
			c10.016,2.272,19.36,6.496,27.072,12.768c6.88,5.568,7.904,15.648,2.304,22.496c-5.6,6.88-15.68,7.872-22.496,2.304
			C208.832,130.688,200.704,128,192,128c-17.344,0-32,10.976-32,24s14.656,24,32,24c35.296,0,64,25.12,64,56
			c0,26.016-20.48,47.744-48,54.016V304c0,8.832-7.168,16-16,16c-8.832,0-16-7.168-16-16v-18.016
			c-10.016-2.272-19.36-6.496-27.072-12.768c-6.88-5.6-7.904-15.68-2.304-22.528c5.6-6.912,15.648-7.872,22.496-2.304
			C175.168,253.312,183.296,256,192,256c17.344,0,32-10.976,32-24s-14.656-24-32-24c-35.296,0-64-25.12-64-56
			C128,125.984,148.48,104.256,176,97.984z M368,448H144c-8.832,0-16-7.168-16-16c0-8.832,7.168-16,16-16h224
			c8.832,0,16,7.168,16,16C384,440.832,376.832,448,368,448z M368,384H144c-8.832,0-16-7.168-16-16c0-8.832,7.168-16,16-16h224
			c8.832,0,16,7.168,16,16C384,376.832,376.832,384,368,384z M368,320h-64c-8.832,0-16-7.168-16-16c0-8.832,7.168-16,16-16h64
			c8.832,0,16,7.168,16,16C384,312.832,376.832,320,368,320z M368,256h-64c-8.832,0-16-7.168-16-16c0-8.832,7.168-16,16-16h64
			c8.832,0,16,7.136,16,16C384,248.832,376.832,256,368,256z"
            />
          </G>
        </G>
        <G></G>
        <G></G>
        <G></G>
        <G></G>
        <G></G>
        <G></G>
        <G></G>
        <G></G>
        <G></G>
        <G></G>
        <G></G>
        <G></G>
        <G></G>
        <G></G>
        <G></G>
      </G>
    ),
    viewBox: "0 0 512 512",
  },
  Refresh: {
    svg: (
      <G {...{ tabIndex: -1 }}>
        <G>
          <Path
            d="M268.175,488.161c98.2-11,176.9-89.5,188.1-187.7c14.7-128.4-85.1-237.7-210.2-239.1v-57.6c0-3.2-4-4.9-6.7-2.9
		l-118.6,87.1c-2,1.5-2,4.4,0,5.9l118.6,87.1c2.7,2,6.7,0.2,6.7-2.9v-57.5c87.9,1.4,158.3,76.2,152.3,165.6
		c-5.1,76.9-67.8,139.3-144.7,144.2c-81.5,5.2-150.8-53-163.2-130c-2.3-14.3-14.8-24.7-29.2-24.7c-17.9,0-31.9,15.9-29.1,33.6
		C49.575,418.961,150.875,501.261,268.175,488.161z"
          />
        </G>
        <G></G>
        <G></G>
        <G></G>
        <G></G>
        <G></G>
        <G></G>
        <G></G>
        <G></G>
        <G></G>
        <G></G>
        <G></G>
        <G></G>
        <G></G>
        <G></G>
        <G></G>
      </G>
    ),
    viewBox: "0 0 489.533 489.533",
  },
  CaretRight: {
    svg: (
      <Path
        fill="currentColor"
        d="M0 384.662V127.338c0-17.818 21.543-26.741 34.142-14.142l128.662 128.662c7.81 7.81 7.81 20.474 0 28.284L34.142 398.804C21.543 411.404 0 402.48 0 384.662z"
      />
    ),
    viewBox: "0 0 192 512",
  },
  Stocks: {
    svg: (
      <Path
        {...{ tabIndex: -1 }}
        id="ic_trending_up_24px"
        d="M10.306,6l1.359,1.359-2.9,2.9L6.4,7.881,2,12.283l.836.836L6.4,9.56l2.373,2.373L12.507,8.2,13.865,9.56V6Z"
        transform="translate(-2 -6)"
      />
    ),
    viewBox: "0 0 11.865 7.119",
  },
  Save: {
    svg: (
      <G {...{ tabIndex: -1 }}>
        <G>
          <Path d="m142 143.003h139v-143c-49.379 0-107.674 0-154 0v128c0 8.271 6.729 15 15 15z" />
          <Path d="m345 128.003v-128c-9.97 0-21.461 0-34 0v143h19c8.271 0 15-6.729 15-15z" />
          <Path d="m127 512.003h218v-161h-218z" />
          <Path d="m511.927 126.537c-.279-2.828-1.38-5.667-3.315-8.027-.747-.913 6.893 6.786-114.006-114.113-2.882-2.882-6.794-4.396-10.612-4.394-.789 0-3.925 0-8.995 0v128c0 24.813-20.187 45-45 45-14.028 0-186.064 0-188 0-24.813 0-45-20.187-45-45v-128c-29.589 0-49.82 0-52 0-24.813 0-45 20.187-45 45v422c0 24.813 20.187 45 45 45h52c0-10.815 0-201.797 0-210 0-24.813 20.187-45 45-45h188c24.813 0 45 20.187 45 45v210h92c24.813 0 45-20.187 45-45 .001-364.186.041-339.316-.072-340.466z" />
          <path d="m330 287.003h-188c-8.271 0-15 6.729-15 15v19h218v-19c0-8.271-6.729-15-15-15z" />
        </G>
      </G>
    ),
    viewBox: "0 0 512 512",
  },
  CircleExclamation: {
    svg: (
      <Path d="M256 0C114.6 0 0 114.6 0 256s114.6 256 256 256s256-114.6 256-256S397.4 0 256 0zM232 152C232 138.8 242.8 128 256 128s24 10.75 24 24v128c0 13.25-10.75 24-24 24S232 293.3 232 280V152zM256 400c-17.36 0-31.44-14.08-31.44-31.44c0-17.36 14.07-31.44 31.44-31.44s31.44 14.08 31.44 31.44C287.4 385.9 273.4 400 256 400z" />
    ),
    viewBox: "0 0 512 512",
  },
  Edge: {
    svg: (
      <G>
        <Path d="M27.996 0h4.008a2.158 2.158 0 0 0 .292.05 53.957 53.957 0 0 1 6.436.612 44.094 44.094 0 0 1 9.908 2.65A24.655 24.655 0 0 1 56.37 8a11.188 11.188 0 0 1 3.249 4.882c.171.547.254 1.119.378 1.68v1.47a.687.687 0 0 0-.057.153A8.746 8.746 0 0 1 58.555 20a15.88 15.88 0 0 1-5.057 4.811 36.442 36.442 0 0 1-12.439 4.717 50.883 50.883 0 0 1-7.428.957c-.542.03-1.081.077-1.625.114h-4.01a2.8 2.8 0 0 0-.326-.051 53.865 53.865 0 0 1-6.829-.678 43.412 43.412 0 0 1-9.881-2.748 24.092 24.092 0 0 1-7.43-4.617A11.032 11.032 0 0 1 .3 17.46c-.13-.467-.2-.95-.3-1.426v-1.465a.673.673 0 0 0 .057-.153 8.556 8.556 0 0 1 1.181-3.471 15.254 15.254 0 0 1 4.876-4.9 32.693 32.693 0 0 1 9.5-4.171A50.709 50.709 0 0 1 26.27.123C26.846.089 27.421.042 27.996 0zm22.2 9.946c-.035-.057-.089-.153-.149-.245A15.548 15.548 0 0 0 45.194 5 27.492 27.492 0 0 0 31.454.941a31.736 31.736 0 0 0-5.8.254 27.852 27.852 0 0 0-8.674 2.573 17.919 17.919 0 0 0-6.272 4.874c-.327.413-.617.854-.967 1.34.228-.021.358-.043.489-.043 1.593 0 3.187-.064 4.771.024a2.87 2.87 0 0 1 2.564 3.116A2.84 2.84 0 0 1 14.71 15.7a31.4 31.4 0 0 1-5.275-.156 2.322 2.322 0 0 0 2.155 2.5c.444.023.892.007 1.332.057s.673.413.632.937a.711.711 0 0 1-.74.74q-.618.018-1.236 0a3.855 3.855 0 0 1-2.358-.889c-.123-.1-.243-.206-.419-.355.044.146.06.221.089.29.136.316.262.637.416.945a14.53 14.53 0 0 0 5.077 5.553 26.738 26.738 0 0 0 13.057 4.273 32.219 32.219 0 0 0 6.337-.116 28.336 28.336 0 0 0 8.366-2.23 18.486 18.486 0 0 0 7.171-5.308 10.618 10.618 0 0 0 2.456-6.792c0-.14-.018-.28-.029-.459a1.235 1.235 0 0 0-.145.108 2.82 2.82 0 0 1-2.3.92 31 31 0 0 1-5.071-.178 2.313 2.313 0 0 0 2.124 2.513c.421.035.846.018 1.267.045.494.031.724.315.723.854s-.236.822-.735.834a15.019 15.019 0 0 1-1.5-.016 4.074 4.074 0 0 1-3.6-3.664 55.813 55.813 0 0 1-.057-3.471 2.737 2.737 0 0 1 2.569-2.675c1.72-.052 3.454-.014 5.181-.014zM47.422 14c.634 0 1.269.02 1.9-.009a1.764 1.764 0 0 0 .786-.208 1.1 1.1 0 0 0 .462-1.283 1.22 1.22 0 0 0-1.184-.858c-1.346-.01-2.692-.005-4.041 0a1.114 1.114 0 0 0-.967.5 1.082 1.082 0 0 0-.094 1.166A1.185 1.185 0 0 0 45.42 14zm-34.794-.017c.657 0 1.313.011 1.97-.006a1.556 1.556 0 0 0 .639-.141 1.119 1.119 0 0 0 .569-1.27 1.2 1.2 0 0 0-1.2-.93c-1.324-.009-2.649 0-3.973 0a1.175 1.175 0 1 0-.015 2.344c.67.009 1.338 0 2.005 0z" />
        <Path d="M26.863 10.101a2.353 2.353 0 0 0-2.283-2.543c-.344-.014-.69 0-1.035-.009a.77.77 0 0 1-.8-.867c-.006-.545.268-.866.793-.86a9.6 9.6 0 0 1 1.826.1A4.06 4.06 0 0 1 28.6 9.751c.064 2.113.108 4.23.057 6.343a3.9 3.9 0 0 1-3.825 3.68 20.014 20.014 0 0 1-2.7-.074 4 4 0 0 1-3.362-3.732 23.844 23.844 0 0 1 .005-2.567 3.874 3.874 0 0 1 3.418-3.432c1.317-.085 2.645-.025 3.967-.012a3.774 3.774 0 0 1 .703.144zm.076 4.3h-.012c0-.523.009-1.046 0-1.569a1.194 1.194 0 0 0-1.188-1.2c-1-.014-2-.019-3 0a2.261 2.261 0 0 0-2.219 2 16.521 16.521 0 0 0 0 2.163 2.2 2.2 0 0 0 1.792 2.157 14.679 14.679 0 0 0 2.493.078 2.22 2.22 0 0 0 2.142-2.07c.016-.513-.009-1.037-.009-1.562z" />
        <Path d="M38.61 19.679c-.544.04-1.07.1-1.6.11-.924.015-1.848.017-2.772-.01a4.05 4.05 0 0 1-3.843-3.774 16.3 16.3 0 0 1 0-2.5 3.881 3.881 0 0 1 3.8-3.561 13.949 13.949 0 0 1 2.827.1 4.081 4.081 0 0 1 3.272 3.9c.026 1.947.057 3.895.066 5.843a3.962 3.962 0 0 1-4.018 4.084c-.345 0-.69.007-1.035-.009a.757.757 0 0 1-.75-.845.728.728 0 0 1 .7-.842c.4-.031.8-.008 1.2-.038a2.242 2.242 0 0 0 2.153-2.458zm-2.776-1.626v.025h1.435a1.209 1.209 0 0 0 1.327-1.353q-.017-1.385-.042-2.77a2.339 2.339 0 0 0-2.025-2.256 13.26 13.26 0 0 0-2.264-.035 2.3 2.3 0 0 0-2.179 2.411c0 .6.013 1.2.044 1.8a2.3 2.3 0 0 0 2.137 2.173c.521.031 1.045.003 1.567.003z" />
        <Path d="M17.871 24.097v-2.86h.357v2.86z" />
        <Path d="M19.299 24.097a.583.583 0 0 1-.413-.147.5.5 0 0 1-.159-.385v-1.111a.469.469 0 0 1 .151-.369.608.608 0 0 1 .421-.135h.654a.607.607 0 0 1 .414.137.463.463 0 0 1 .157.367v1.115a.493.493 0 0 1-.163.377.578.578 0 0 1-.409.151zm-.213-.643a.325.325 0 0 0 .057.218.247.247 0 0 0 .194.068h.575q.253 0 .254-.27v-.9a.226.226 0 0 0-.254-.258h-.574a.226.226 0 0 0-.254.258z" />
        <Path d="M21.032 24.795v-.353h1.154a1.007 1.007 0 0 0 .127 0 .17.17 0 0 0 .064-.043.269.269 0 0 0 .079-.2v-.1h-.854a.529.529 0 0 1-.4-.171.579.579 0 0 1-.161-.415v-1.011a.559.559 0 0 1 .145-.395.474.474 0 0 1 .363-.156h.757a.482.482 0 0 1 .367.141.535.535 0 0 1 .133.383v1.793a.487.487 0 0 1-.162.385.651.651 0 0 1-.444.143zm.369-1.313a.268.268 0 0 0 .064.186.211.211 0 0 0 .166.072h.626q.2 0 .2-.258v-.932q0-.242-.194-.242h-.6a.265.265 0 0 0-.188.065.232.232 0 0 0-.069.177z" />
        <Path d="M23.242 21.486a.249.249 0 0 1 .068-.178.223.223 0 0 1 .171-.072.247.247 0 0 1 .181.073.241.241 0 0 1 .073.176.246.246 0 1 1-.492 0zm.072 2.61V21.95h.353v2.146z" />
        <Path d="M24.099 24.097v-.355h1.1q.146 0 .146-.215v-.166q0-.2-.21-.2h-.484a.591.591 0 0 1-.369-.1.411.411 0 0 1-.123-.153.437.437 0 0 1-.047-.192v-.27a.5.5 0 0 1 .126-.361.462.462 0 0 1 .348-.131h1.116v.357h-1.081a.151.151 0 0 0-.111.044.155.155 0 0 0-.043.114v.155a.159.159 0 0 0 .057.125.209.209 0 0 0 .141.049h.532a.5.5 0 0 1 .357.147.472.472 0 0 1 .151.349v.337a.455.455 0 0 1-.139.326.437.437 0 0 1-.322.143z" />
        <Path d="M26.137 24.097v-2.86h.357v.714h.365v.357h-.365v1.789z" />
        <Path d="M27.006 21.486a.249.249 0 0 1 .067-.178.224.224 0 0 1 .171-.072.245.245 0 0 1 .18.073.241.241 0 0 1 .073.176.246.246 0 0 1-.492 0zm.071 2.61V21.95h.353v2.146z" />
        <Path d="M29.355 24.097h-.822a.608.608 0 0 1-.425-.155.5.5 0 0 1-.171-.389v-1.059a.635.635 0 0 1 .044-.26.376.376 0 0 1 .154-.164.662.662 0 0 1 .393-.119h.818v.357h-.814a.22.22 0 0 0-.234.234v.932a.269.269 0 0 0 .072.186.228.228 0 0 0 .174.08h.813z" />
        <Path d="M29.68 24.097v-.355h1.1q.147 0 .147-.215v-.166c0-.135-.071-.2-.211-.2h-.484a.589.589 0 0 1-.369-.1.406.406 0 0 1-.123-.153.437.437 0 0 1-.047-.192v-.27a.5.5 0 0 1 .126-.361.464.464 0 0 1 .348-.131h1.116v.357h-1.081a.149.149 0 0 0-.11.044.155.155 0 0 0-.044.114v.155a.159.159 0 0 0 .057.125.21.21 0 0 0 .141.05h.532a.5.5 0 0 1 .357.147.469.469 0 0 1 .151.349v.337a.455.455 0 0 1-.139.325.437.437 0 0 1-.322.143z" />
      </G>
    ),
    viewBox: '0 0 60 30',
  },
  SmallEdge: {
    svg: (
      <G transform="translate(22279.998 14796)">
        <Path
          d="M235.335,7.1a4.79,4.79,0,0,1,1.464,3.5,4.81,4.81,0,0,1-1.464,3.529,4.764,4.764,0,0,1-3.49,1.464h-6.993a5.228,5.228,0,0,1-2.032-.444v.444a4.019,4.019,0,0,0,4.032,4.013h1.5a1.307,1.307,0,0,1,1.457,1.464,1.307,1.307,0,0,1-1.457,1.49h-1.5a6.918,6.918,0,0,1-6.973-6.967V10.5a4.941,4.941,0,0,1,4.993-4.862h6.993a4.758,4.758,0,0,1,3.47,1.457ZM222.82,10.724a2.026,2.026,0,0,0,.654,1.346,1.915,1.915,0,0,0,1.4.555h6.993a2.008,2.008,0,0,0,2-2.032,2.006,2.006,0,0,0-2-2h-6.993a1.915,1.915,0,0,0-1.4.555,2.059,2.059,0,0,0-.654,1.353Z"
          transform="translate(-22484.926 -14797.954)"
        />
        <Path
          d="M220.265,0c-31.173,1.046-30.062,22.331-2.4,24.18C252.17,24.912,251.118.386,220.265,0Zm-.085,23.409c-23.069-1.006-21.115-22.1,0-22.592C243.243,1.823,241.289,22.919,220.18,23.409Z"
          transform="translate(-22476.998 -14796)"
        />
      </G>
    ),
    viewBox: '0 0 46 24',
  },
};
